import React from 'react';
import moment from 'moment';

export const DateFormatter = (props) => {
  const { value } = props;
  let text = '';

  if (value) {
    text = new Date(value.toString());
    text = moment(text).format('MM/DD/YYYY');
  }

  return <span>{text}</span>;
};

export const DateTimeFormatter = (props) => {
  const { value } = props;
  let text = '';

  if (value) {
    text = new Date(value.toString());
    text = moment(text).format('DD/MM/YYYY h:mm a');
  }
 
  return <span>{text}</span>;
};

export const  DateTimeAndFormatter = (props) => {
  const { value } = props;
  let text = '';

  if (value) {
    text = new Date(value.toString());
    text = moment(text).format('MMM DD, YYYY h:mm a');
  }

  
  return <span>{text}</span>;
};
